import { getRequiredOnboarding } from 'pricing-pages-lib/api/RequiredOnboardingApi';
import { REQUIRED_ONBOARDING } from './constants/RequestedDataTypes';
import makeFetchRequest from './helpers/makeFetchRequest';
import { createRequestActions, createRequestTypes } from './helpers/RequestActions';
export const FetchRequiredOnboardingRequestTypes = createRequestTypes(REQUIRED_ONBOARDING);
export const FetchRequiredOnboardingActions = createRequestActions(FetchRequiredOnboardingRequestTypes);
export const fetchRequiredOnboarding = () => makeFetchRequest({
  requestActions: FetchRequiredOnboardingActions,
  fetch: getRequiredOnboarding
});